import React, { useEffect, useState, useRef } from "react"
import { motion } from "framer-motion"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper.min.css"
import "swiper/components/effect-coverflow/effect-coverflow.min.css"
import "swiper/components/pagination/pagination.min.css"
import SwiperCore, { EffectCoverflow, Pagination } from "swiper/core"
import "./Favourites.css"
import shareIcon from "./share.svg"
// import compareIcon from "./compare.svg"

import FavouritesForm from "../../components/FavouritesForm"
import { useLocation } from "react-use"
import { io } from "socket.io-client"
import FavouriteCard from "../../components/FavouriteCard"
import { useStore } from "../../state/store"
import { returnsPlotNumber } from "../../components/ApartmentFinder/Utils/Helpers"

// install Swiper modules
SwiperCore.use([EffectCoverflow, Pagination])

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}

const url = process.env.REACT_APP_MARKETING_SUITE
const role = process.env.REACT_APP_ROLE
export const numbers = { 1: "one", 2: "two", 3: "three", 4: "four" }

export default function Favourites() {
  const [showForm, setShowForm] = useState(false)
  const [showCompare, setShowCompare] = useState(false)
  const [swiper, setSwiper] = useState(null)
  const socket = useRef()

  const setFavouritesActive = useStore(state => state.setFavouritesActive)
  const favourites = useStore(state => state.favourites)
  const apartments = useStore(state => state.apartments)
  const favouriteApartments =
    apartments !== null ? apartments.filter(a => favourites.includes(Number(a.PlotNumber))) : []

  useEffect(() => {}, [favourites, apartments])

  const setFavourites = useStore(state => state.setShare)
  const location = useLocation()

  useEffect(() => {
    setFavouritesActive(true)

    return () => setFavouritesActive(false)
  }, [])

  useEffect(() => {
    const units = new URLSearchParams(location.search).get("units")

    // console.log("UNITS", units)
    if (units) {
      setFavourites(units.split(","))
    }
  }, [])

  useEffect(() => {
    /**
     * Make a socket connection if there is a role.
     */

    if (role) {
      socket.current = io(url)
      if (role === "recipient") {
        socket.current.on("favourites", data => {
          if (data[0] !== showCompare) {
            setShowCompare(data[0])
          } else {
            if (!data[0] && swiper) {
              try {
                swiper.slideTo(data[1])
              } catch (error) {
                console.log(error)
              }
            }
          }
        })
      }
    }
  }, [swiper])

  useEffect(() => {
    if (role === "sender" && swiper) {
      socket.current.emit("favourites", [showCompare, swiper.activeIndex])
    }
  }, [showCompare])

  const slideChange = e => {
    if (socket.current && role === "sender") {
      socket.current.emit("favourites", [false, e.activeIndex])
    }
  }
  const show360 = useStore(s => s.show360)

  return (
    <>
      <motion.div
        className="favourites"
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
      >
        {favourites.length > 0 && (
          <Swiper
            noSwiping={true}
            noSwipingClass={"noSwiping"}
            navigation={true}
            pagination={{
              clickable: true
            }}
            scrollbar={{ draggable: true }}
            slidesPerView={"auto"}
            grabCursor={true}
            effect="coverflow"
            coverflowEffect={{
              rotate: 20,
              stretch: 0,
              depth: 20,
              modifier: 1,
              slideShadows: false
            }}
            spaceBetween={300}
            onSwiper={setSwiper}
            onSlideChange={slideChange}
            className="swiper"
          >
            {favouriteApartments.map((fav, index) => (
              <SwiperSlide key={index} className={show360 ? "noSwiping" : ""}>
                {apartments && (
                  <div
                    style={{
                      pointerEvents: "none",
                      position: "absolute",
                      height: "44vw",
                      width: "70vw"
                    }}
                  >
                    <FavouriteCard isFromFavourites={true} id={fav.PlotNumber} />
                  </div>
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        {favourites.length === 0 && <div className="no-data">No Favourites Currently Selected</div>}
      </motion.div>
      {showForm && <FavouritesForm setShowForm={setShowForm} />}
      {/* {showCompare && <Compare setShow={setShowCompare} />} */}
      <div className="favourites-buttons">
        {/* <img src={compareIcon} alt="Compare" onClick={() => setShowCompare(true)} /> */}
        <img src={shareIcon} alt="Share" onClick={() => setShowForm(true)} />
      </div>
    </>
  )
}
